// extracted by mini-css-extract-plugin
module.exports = {"container":"EmojiPicker-styles_container__3Ru1r","triggerBtn":"EmojiPicker-styles_triggerBtn__3_Nte"};